import { NumberUtils } from '@pk/powerkioskutils';

export class ViewSupplierUpcomingOpportunitySummary {
	public totalInvitedSessions: number;
	public totalAnnualUsageElec: number;
	public totalAnnualUsageGas: number;
	public totalAnnualUsageElecMWh: number;
	public totalAnnualUsageGasDth: number;

	constructor(data?: Partial<ViewSupplierUpcomingOpportunitySummary>) {
		Object.assign(this, data);
		this.totalAnnualUsageElecMWh = NumberUtils.amountToUnits(this.totalAnnualUsageElec, 'mwh');
		this.totalAnnualUsageGasDth = NumberUtils.amountToUnits(this.totalAnnualUsageGas, 'dth');
	}
}
